export var TicketRedemptionCodeFormFieldName;
(function (TicketRedemptionCodeFormFieldName) {
    TicketRedemptionCodeFormFieldName["Code"] = "Code";
    TicketRedemptionCodeFormFieldName["Type"] = "Type";
    TicketRedemptionCodeFormFieldName["Pin"] = "Pin";
})(TicketRedemptionCodeFormFieldName || (TicketRedemptionCodeFormFieldName = {}));
